"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14906%3A70))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:37:20.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRImageLandscape = createSVGIcon(
  <path
    d="M2.25 16.5h19.5m-.5-1.709-6.028-7.23a.337.337 0 0 0-.519 0L7.25 16.5M2.75 2.75v18.5h18.5V2.75zm7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
    stroke="currentColor"
    strokeWidth="1.5"
  />,
  "BSRImageLandscape",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
